import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import Sidebar from "../../../components/Sidebar/Sidebar";
import useGlobalContext from "../../../hooks/useGlobalContext";

const HomeTwoHeader = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { stickyMenu } = useGlobalContext();

  const handleScrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <header>
        <div className="header__area p-relative header__transparent">
          <div className="header__top d-none d-md-block" style={{ backgroundColor: "#2a2a2a", padding: "6px 0" }}>
            <div className="container">
              <div className="d-flex justify-content-end align-items-center">
                <a href="tel:+18773007146" style={{ color: "#fff", fontSize: "14px", textDecoration: "none", display: "flex", alignItems: "center", gap: "6px" }}>
                  <FaPhoneAlt style={{ fontSize: "12px" }} /> +1 (877) 300-7146
                  <span style={{ fontSize: "11px", color: "#aaa", marginLeft: "6px" }}>— Used by Spectrum Business for outbound calls</span>
                </a>
              </div>
            </div>
          </div>
          <div
            id="header__sticky"
            className="sticky header__bottom header__bottom-2"
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                  <div className="logo">
                    <NavLink to="/">
                      <img src="assets/img/logoV.png" alt="logo" style={{ objectFit: "contain", width: "120px" }} />
                    </NavLink>
                  </div>
                  <div className="logo-gradient">
                    <NavLink to="/">
                      <img src="assets/img/logoV.png" alt="logo" style={{ objectFit: "contain", width: "120px" }} />
                    </NavLink>
                  </div>
                </div>
                <div className="col-xl-9 col-lg-9 col-md-6 col-sm-6 col-6">
                  <div className="header__bottom-right d-flex justify-content-end align-items-center">
                    <div className="main-menu menu_wrapper_one">
                      <nav id="mobile-menu">
                        <ul>
                          <li>
                            <NavLink
                              to="/"
                              className={({ isActive }) => (isActive ? "active" : "inactive")}
                            >
                              Home
                            </NavLink>
                          </li>
                          <li>
                            <a
                              href="#about"
                              onClick={(e) => handleScrollToSection(e, 'about')}
                              className="inactive"
                            >
                              About Us
                            </a>
                          </li>
                          <li>
                            <a
                              href="#services"
                              onClick={(e) => handleScrollToSection(e, 'services')}
                              className="inactive"
                            >
                              Services
                            </a>
                          </li>
                          <li>
                            <NavLink
                              to="/jobs"
                              className={({ isActive }) => (isActive ? "active" : "inactive")}
                            >
                              Jobs
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/compliance"
                              className={({ isActive }) => (isActive ? "active" : "inactive")}
                            >
                              Compliance
                            </NavLink>
                          </li>
                          {/* <li>
                            <NavLink
                              to="#"
                              className={({ isActive }) => (isActive ? "active" : "")}
                            >
                              Contact
                            </NavLink>
                          </li> */}
                        </ul>
                      </nav>
                    </div>
                    <div className="header__btn d-none d-sm-block d-xl-block ml-50">
                      <Link to="/contact-us" className="z-btn z-btn-white z-btn-white-2">
                        Contact Us
                      </Link>
                    </div>
                    <div onClick={handleShow} className="sidebar__menu d-lg-none">
                      <div className="sidebar-toggle-btn" id="sidebar-toggle">
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Sidebar show={show} handleClose={handleClose} />
    </>
  );
};

export default HomeTwoHeader;